const TOKEN_KEY = 'hualing_token'
const USER_KEY = 'hualing_user'

// Token操作
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

// 用户信息操作
export function getUser() {
  const user = localStorage.getItem(USER_KEY)
  return user ? JSON.parse(user) : null
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function removeUser() {
  localStorage.removeItem(USER_KEY)
}

// 清除所有
export function clearAll() {
  removeToken()
  removeUser()
}

export function getCookieToken() {
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const c = cookies[i].trim()
    if (c.startsWith('hualing_token=')) {
      return c.substring('hualing_token='.length)
    }
  }
  return ''
}